export const discountPlanData = [
  {
    id:"1",
    PlanName: "Standard Plan",
    Customers: "All Customers",
    Status: "Active",
  },
  {
    id:"2",
    PlanName: "Membership Plan",
    Customers: "Members Only",
    Status: "Active",
  },
  {
    id:"3",
    PlanName: "Premium Plan",
    Customers: "High-Spending Customers",
    Status: "Active",
  },
  {
    id:"4",
    PlanName: "Seasonal Plan",
    Customers: "All Customers",
    Status: "Active",
  },
  {
    id:"5",
    PlanName: "Student Plan",
    Customers: "Students",
    Status: "Active",
  },
  {
    id:"6",
    PlanName: "Free Shipping Plan",
    Customers: "Online Customers",
    Status: "Active",
  },
  {
    id:"7",
    PlanName: "Celebration Plan",
    Customers: "All Customers",
    Status: "Active",
  },
];
